__webpack_require__.p = "https://matchcenter-api.24media.gr/widget/85a3d4f1cab537204723/";